import './AssetField.scss';
import AssetEditModal from './AssetEditModal';
import AssetSelectModal from './AssetSelectModal';
import ImageAsset from './ImageAsset';
import React from 'react';
import asset from '../../model/asset';
import tagModel from '../../model/tag';
import {useTagsHoC} from '../../providers/TagsProvider';

class AssetField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selecting: false,
      uploading: false,
      editing: false,
      isVideo: false,
      error: ''
    };

    this.handleToggleEditAsset = this.handleToggleEditAsset.bind(this);
    this.handleRemoveAsset = this.handleRemoveAsset.bind(this);
    this.handleToggleSelector = this.handleToggleSelector.bind(this);
    this.handleSelection = this.handleSelection.bind(this);
    this.handleUpload = this.handleUpload.bind(this);

    this.imageRef = React.createRef();
  }

  handleToggleEditAsset() {
    if (!this.props.disabled) {
      this.setState({
        editing: !this.state.editing
      });
    }
  }

  handleRemoveAsset() {
    if (!this.props.disabled) {
      this.props.onChange(this.props.name, null);
    }
  }

  handleToggleSelector(type) {
    if (!this.props.disabled) {
      this.setState({
        selecting: !this.state.selecting,
        isVideo: type === 'video'
      });
    }
  }

  handleSelection(selection) {
    if (!this.props.disabled) {
      this.props.onChange(this.props.name, selection);
      this.setState({
        selecting: false,
        editing: false
      });
    }
  }

  async handleUpload() {
    if (!this.imageRef.current.files.length) {
      return;
    }

    const image = this.imageRef.current.files[0];

    if (!this.props.disabled) {
      this.setState({
        uploading: true,
        error: ''
      });

      let assetTagIDs = [];
      // If we are dealing with any predefined tags then we fetch existing tags, check which ones we already have and create the new ones.
      if (Array.isArray(this.props.predefinedTags) && this.props.predefinedTags.length > 0) {
        assetTagIDs = await tagModel.getOrCreateTagIdsFromTags(this.props.predefinedTags).catch(() => {
          this.setState({
            uploading: false,
            error: 'Feil ved opplasting av fil (Tag feilet). Ta kontakt!'
          });

          return null;
        });

        if (assetTagIDs === null) {
          return;
        }

        // Refresh the tags in the provider via the HOC.
        // Doing this async however if a race condition appears this can be awaited.
        this.props.tags.refreshTags();
      }

      await asset.upload({
        filename: image.name,
        contentType: image.type,
        content: image
      }, assetTagIDs).then((asset) => {
        this.handleSelection(asset);
      }).then(() => {
        this.setState({
          uploading: false
        });
      });
    }
  }

  render() {
    const image = this.props.value;
    let typeString = 'bilde';
    let accept = 'image/*';
    if (this.props.allowVideo) {
      typeString += ' eller video';
      accept += ',video/*';
    }

    return (
      <div className={`${this.props.disabled ? 'disabled ' : ''}contentful-asset-field`}>
        {image &&
          <div>
            <ImageAsset
              asset={image}
              disabled={this.props.disabled}
              onEdit={this.handleToggleEditAsset}
              onRemove={this.handleRemoveAsset}
            />

            {this.state.error && <p>
              <span className="text-danger">{this.state.error}</span>
            </p>}
            <p className="text-left">
              <a
                className={`${(this.state.selecting ? 'active ' : '') + (this.props.disabled ? 'disabled ' : '')}btn btn-default`}
                onClick={() => this.handleToggleSelector('image')}
              >
                <i className="fa fa-pencil" aria-hidden="true"></i> Velg annet bilde
              </a>
              &nbsp;
              {this.props.allowVideo && <>
                <a
                  className={`${(this.state.selecting ? 'active ' : '') + (this.props.disabled ? 'disabled ' : '')}btn btn-default`}
                  onClick={() => this.handleToggleSelector('video')}
                >
                  <i className="fa fa-pencil" aria-hidden="true"></i> Velg annen video
                </a>
                &nbsp;
              </>}

              {this.state.uploading &&
                <span><i className="fa fa-spinner fa-pulse fa-fw"></i> Laster opp...</span>
              }
              {!this.state.uploading &&
                <label>
                  <input className="hidden" type="file" ref={this.imageRef} onChange={this.handleUpload} accept={accept} />
                  <span className={`${this.props.disabled ? 'disabled ' : ''}btn btn-default`}><i className="fa fa-cloud-upload" aria-hidden="true"></i> Last opp annet</span>
                </label>
              }

            </p>
          </div>
        }
        {!image &&
          <div>
            <div className="contentful-asset-field-slot well h4">
              {typeString} mangler.
            </div>
            {this.state.error && <p>
              <span className="text-danger">{this.state.error}</span>
            </p>}
            <p className="text-left">
              <a
                className={`${(this.state.selecting ? 'active ' : '') + (this.props.disabled ? 'disabled ' : '')}btn btn-default`}
                onClick={() => this.handleToggleSelector('image')}
              >
                <i className="fa fa-pencil" aria-hidden="true"></i> Velg bilde
              </a>
              &nbsp;
              {this.props.allowVideo && <>
                <a
                  className={`${(this.state.selecting ? 'active ' : '') + (this.props.disabled ? 'disabled ' : '')}btn btn-default`}
                  onClick={() => this.handleToggleSelector('video')}
                >
                  <i className="fa fa-pencil" aria-hidden="true"></i> Velg video
                </a>
                &nbsp;
              </>}
              {this.state.uploading &&
                <span><i className="fa fa-spinner fa-pulse fa-fw"></i> Laster opp...</span>
              }
              {!this.state.uploading &&
                <label>
                  <input className="hidden" type="file" ref={this.imageRef} onChange={this.handleUpload} accept="image/*" />
                  <span className={`${this.props.disabled ? 'disabled ' : ''}btn btn-default`}><i className="fa fa-cloud-upload" aria-hidden="true"></i> Last opp</span>
                </label>
              }
            </p>
          </div>
        }

        <AssetSelectModal
          show={this.state.selecting}
          onSelect={this.handleSelection}
          onHide={this.handleToggleSelector}
          isVideo={this.state.isVideo}
        />

        <AssetEditModal
          asset={this.props.value}
          show={this.state.editing}
          onChange={this.handleSelection}
          onHide={this.handleToggleEditAsset}
        />
      </div>
    );
  }
}

AssetField.defaultProps = {
  value: null,
  name: 'asset',
  disabled: false,
  allowVideo: false,
  onChange: () => {},
  predefinedTags: []
};

export default useTagsHoC(AssetField);
